module.exports = __webpack_public_path__ + "8a235722f1ff41f2a6da36b07f72f1da.svg";